import { render } from "./RightMenuComponent.vue?vue&type=template&id=33a19d9a"
import script from "./RightMenuComponent.vue?vue&type=script&lang=js"
export * from "./RightMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yq-qianduan/Documents/yq-home-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__